/* Regnum floating WhatsApp picker. Toggle panel on click, close on
   outside click or Escape. Pattern mirrors regnum-share.js. */
(function () {
  'use strict';

  /* Force-style the button via inline style with !important.
     Theme's button base CSS keeps winning despite specificity in our CSS,
     so we apply the inline style directly. setProperty(prop, val, 'important')
     beats any external !important rule. */
  function forceButtonStyle(btn) {
    if (!btn) return;
    var styles = {
      'width': '56px', 'height': '56px',
      'min-width': '56px', 'min-height': '56px',
      'max-width': '56px', 'max-height': '56px',
      'border-radius': '50%',
      'background': '#25D366', 'background-color': '#25D366',
      'background-image': 'none',
      'color': '#ffffff',
      'border': 'none',
      'padding': '0', 'margin': '0',
      'display': 'inline-flex',
      'align-items': 'center', 'justify-content': 'center',
      'cursor': 'pointer',
      'box-shadow': '0 10px 24px rgba(37,211,102,.35), 0 2px 6px rgba(0,0,0,.12)',
      'transition': 'transform .18s ease, box-shadow .22s ease, background-color .18s ease',
      'font-size': '0',
    };
    Object.keys(styles).forEach(function (k) {
      btn.style.setProperty(k, styles[k], 'important');
    });
  }

  function init() {
    var wrap = document.getElementById('regnum-wa');
    if (!wrap) return;
    var btn = wrap.querySelector('.regnum-wa-btn');
    var panel = wrap.querySelector('.regnum-wa-panel');
    if (!btn || !panel) return;

    forceButtonStyle(btn);
    /* Re-apply at a few intervals in case theme JS overwrites */
    [400, 1200, 3000].forEach(function (ms) {
      setTimeout(function () { forceButtonStyle(btn); }, ms);
    });

    function open() {
      panel.removeAttribute('hidden');
      panel.setAttribute('data-open', '');
      btn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      panel.setAttribute('hidden', '');
      panel.removeAttribute('data-open');
      btn.setAttribute('aria-expanded', 'false');
    }
    function isOpen() { return panel.hasAttribute('data-open'); }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      isOpen() ? close() : open();
    });
    document.addEventListener('click', function (e) {
      if (!isOpen()) return;
      if (wrap.contains(e.target)) return;
      close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) { close(); btn.focus(); }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
